module.exports = __webpack_public_path__ + "static/media/rueckbildung.13b69cdd.jpg";